import styled from "styled-components";

const HubContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export { HubContainer };
